import React, { useState, useEffect, useReducer } from 'react';
import moment from 'moment';
import {
  Menu,
  Row, Col,
  InputNumber,
  Modal,
  Button,
  DatePicker,
  Form, Input, Select, Empty, Dropdown,
  Space,
  Checkbox,
  Divider,
  Tag
} from 'antd';
import {
  CloseOutlined,
  CheckOutlined,
  PlusOutlined,
  CaretDownOutlined,
  ImportOutlined,
  EditOutlined,
  ExclamationCircleOutlined
} from '@ant-design/icons';
import { Page } from '../../components';
import './style';

import { getOrderPendingByBuyerId } from '../../services/Buyer';
import { getListEnabled } from '../../services/Entity';
import {
  getOrderPendingPackageList,
  splitPackageCartonCount
} from '../../services/Order';
import { sum } from '../../utils/Array';
import { toThousands } from '../../utils/Numeric';
import { chkPallet } from '../../utils/Pallet';
export default React.forwardRef((props, ref) => {
  const { mode, container, plan, buyers, company, onCloseCallback, onSaveCallback } = props;
  const [form] = Form.useForm();
  const [isReadonly, setReadonly] = useState(mode != 'new');
  const [orders, setOrders] = useState([]);
  const [allPackages, setAllPackages] = useState([]);
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [buyerId, setBuyerId] = useState(plan ? plan.buyer_id : undefined);
  const [typeId, setTypeId] = useState(plan ? plan.delivery_type_id : undefined);
  const [companyId, setCompanyId] = useState(plan ? plan.company_id : undefined);
  const [planDate, setPlanDate] = useState(plan ? plan.plan_date : undefined);
  const [displayColumn, setDisplayColumn] = useState([0, 1, 2]);
  const [pallets, setPallets] = useState([]);
  const [packages, setPackages] = useState([]);
  const [destinationPortId, setDestinationPortId] = useState(undefined);
  const [transportId, setTransportId] = useState(undefined);
  const [isShowSplit, setShowSplit] = useState(false);
  const [splitValues, setSplitValues] = useState([0]);
  const [selectedPkg, setSelectedPkg] = useState({});
  const [portContainer, setPortContainer] = useState([]);
  const [containerId, setContainerId] = useState(undefined);
  const [limit, setLimit] = useState(0);
  const onSave = async () => {
    const values = await form.validateFields();

    const selectedPallets = pallets.filter(x => x._selected);
    const selectedPalletsCartons = packages.filter(x => selectedPallets.find(y => y.id === x.pallet_id));
    const selectedCartons = packages.filter(x => x._selected && x.pallet_id === -1);

    if (selectedPallets.length === 0 &&
      selectedPalletsCartons.length === 0 &&
      selectedCartons.length === 0) {
      Modal.error({
        title: '无有效数据',
        content: '发货拼托区域无数据！',
      });
      return;
    }
    //if (selectedPallets.filter(x => x._status > 1).length > 0) {
    //  Modal.error({
    //    title: '托盘数据',
    //    content: '当前发货区域存在不符合标准的托盘！',
    //  });
    //  return;
    //}

    if (selectedPallets.filter(x => x._status === 0).length > 0) {
      let count = 0;
      selectedPallets.filter(x => x._status === 0).forEach(x => {
        if (packages.filter(y => y.pallet_id === x.id).length === 0) {
          count++;
        }
      })
      if (count > 0) {
        Modal.error({
          title: '托盘数据异常',
          content: '当前发货区域存在[' + count + ']个空托盘，请移除空托盘之后，重新保存',
        });
        return;
      }
    }
    if (totalDeliveryWeights > limit) {
      Modal.error({
        title: '发货总重量异常',
        content: "当前总重量[" + totalDeliveryWeights.toFixed(2) + "KG]超过港口-集装箱限重 [" + limit + "KG]",
      });
      return;
    }

    if (selectedPallets.filter(x => x._status === 1).length > 0) {
      Modal.confirm({
        title: '确定生成发货计划吗?',
        icon: <ExclamationCircleOutlined />,
        content: <strong>
          当前发货区域存在超重的托盘，是否继续生成发货计划？<br />
          {selectedPallets.length}托 + {sum(selectedCartons, 'carton_count')}箱<br />
          {totalDeliveryWeights.toFixed(2)}KG</strong>,
        okText: '是',
        centered: true,
        okType: 'danger',
        cancelText: '否',
        onOk() {
          if (onSaveCallback) {
            onSavePlan(values, selectedPallets, selectedPalletsCartons, selectedCartons);
          }
          setReadonly(true);
        },
        onCancel() {
          console.log('Cancel');
        },
      });
      return;
    }

    Modal.confirm({
      title: '确定生成发货计划吗?',
      icon: <ExclamationCircleOutlined />,
      content: <strong>
        {selectedPallets.length}托 + {sum(selectedCartons, 'carton_count')}箱<br />
        {totalDeliveryWeights.toFixed(2)}KG</strong>,
      okText: '是',
      centered: true,
      okType: 'danger',
      cancelText: '否',
      onOk() {
        if (onSaveCallback) {
          onSavePlan(values, selectedPallets, selectedPalletsCartons, selectedCartons);
        }
        setReadonly(true);
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  const onSavePlan = (values, selectedPallets, selectedPalletsCartons, selectedCartons) => {
    const orderinfo = [];
    selectedPalletsCartons.forEach(x => {
      const find = orderinfo.find(y => y.order_id === x.order_id);
      if (!find) orderinfo.push({ order_id: x.order_id, no: x.no, po_code: x.po_code });
    });
    selectedCartons.forEach(x => {
      const find = orderinfo.find(y => y.order_id === x.order_id);
      if (!find) orderinfo.push({ order_id: x.order_id, no: x.no, po_code: x.po_code });
    });
    onSaveCallback({
      plan: {
        delivery_type_id: values.delivery_type_id,
        destination_port_id: values.destination_port_id,
        plan_date: values.plan_date,
        buyer_id: values.buyer_id,
        nos: orderinfo.length > 0 ? `'{"${orderinfo.map(x => x.no).join('","')}"}'` : "'{}'",
        po_codes: orderinfo.length > 0 ? `'{"${orderinfo.map(x => x.po_code).join('","')}"}'` : "'{}'",
        order_ids: orderinfo.length > 0 ? `'{${orderinfo.map(x => x.order_id).join(',')}}'` : "'{}'",
        pallet_count: selectedPallets.length,
        carton_count: selectedCartons.filter(x => x.pallet_id === -1).length,
        feight: values.feight || 0,
        ddc: values.ddc || 0,
        delivery_no: values.delivery_no || '',
        container_id: values.container_id
      },
      pkgs: selectedPalletsCartons.concat(selectedCartons).map(x => ({ id: x.id, pallet_id: x.pallet_id }))
    });
  }

  const onChangeSelectedOrder = (values) => {
    values.forEach(x => {
      const find = allPackages.find(y => y.order_id === x);
      if (!find) {
        getOrderPendingPackageList(x).then(data1 => {
          const data2 = [];
          data1.forEach(x => {
            x.weight = x.unit_weight * x.count * 0.001;
            if (!data2.find(p => p.id === x.pallet_id) && x.pallet_id > -1) {
              data2.push({ id: x.pallet_id, supplier_id: x.supplier_id, recive_status: x.pallet_recive_status });
            }
          });
          const temp = [].concat(allPackages);
          temp.push({
            order_id: x,
            packages: data1,
            pallets: data2
          });
          setAllPackages(temp);
        });
      }
    })
    setSelectedOrders(values);
  }

  useEffect(() => {
    let tpallets = [];
    let tpackages = [];
    allPackages.filter(a => selectedOrders.indexOf(a.order_id) > -1).forEach(x => {
      tpallets = tpallets.concat(x.pallets);
      tpackages = tpackages.concat(x.packages);
    });
    tpallets.forEach((x, i) => {
      const find = pallets.find(y => y.id === x.id);
      if (find) {
        if (find._selected) {
          tpallets[i]._selected = true;
        }
      }
    });
    const newPallets = pallets.filter(x => x._isNew);
    tpallets = tpallets.concat(newPallets);

    tpackages.forEach((x, i) => {
      const find = packages.find(y => y.id === x.id);
      if (find) {
        tpackages[i].pallet_id = find.pallet_id;
        if (find._selected) {
          tpackages[i]._selected = true;
        }
      } else {
        const splited = packages.find(z => !tpackages.find(zz => zz.id === z.id));
        if (splited) {
          tpackages[i]._selected = splited._selected;
          tpackages[i].pallet_id = splited.pallet_id;
        }
      }
    });
    setPallets(tpallets);
    setPackages(tpackages);
  }, [selectedOrders, allPackages]);

  useEffect(() => {
    if (containerId && destinationPortId) {
      const limit = (portContainer.find(x => x.container_id === containerId && x.port_id === destinationPortId) || {}).weight;
      setLimit(limit);
    }
  }, [containerId, destinationPortId])

  useEffect(() => {
    getListEnabled('fm_port_container').then(data => setPortContainer(data));
  }, []);

  const onChangeBuyer = (value) => {
    setBuyerId(value);
    setSelectedOrders([]);
    setCompanyId(undefined);
    setDestinationPortId(undefined);
    setTransportId(undefined);
    if (value) getOrderPendingByBuyerId(value).then(data => setOrders(data));
  };


  const onClickSplitOk = () => {
    if (splitValues.length < 2) {
      return;
    }
    splitPackageCartonCount(
      selectedPkg.order_id, selectedPkg.id, selectedPkg.ds, splitValues.map(x => ({
        count: selectedPkg.pcs_per_carton * x,
        carton_count: x,
        weight: selectedPkg.weight * (x * 1.0 / selectedPkg.carton_count)
      }))).then(data => {
        allPackages.forEach((x, i) => {
          if (x.order_id === selectedPkg.order_id) {
            allPackages.splice(i, 1);
          }
        });
        onChangeSelectedOrder(selectedOrders);
        setShowSplit(false);
        setSplitValues([0]);
      });
  }

  const onChangeSplit = (value, index, count) => {
    const temp = [].concat(splitValues);
    temp.splice(index);
    let total = 0;
    temp.forEach((item, index) => {
      total += item;
    });
    if ((total + value) < count) {
      temp[index] = value;
      temp[index + 1] = count - total - value;
    } else {
      temp[index] = count - total;
    }
    setSplitValues(temp);
  }

  const onSplitCarton = (id, count) => {
    const pkg = packages.find(x => x.id === id);
    setSelectedPkg(pkg);
    setShowSplit(true);
  }

  const splitBody = () => {
    if (!selectedPkg) return undefined;
    return <div style={{ padding: '2rem 1rem' }}>
      <span style={{ padding: '0rem 1rem' }}>拆分数量:
        <strong>{selectedPkg.carton_count}</strong>=
        {
          splitValues.map((item, index) => {
            let max = 0;
            splitValues.forEach((item, i) => {
              if (i < index) {
                max += item;
              }
            })
            return <span>
              {index > 0 && '+'}
              <InputNumber
                min={1}
                max={selectedPkg.carton_count - max}
                value={item}
                onChange={(value) => onChangeSplit(value, index, selectedPkg.carton_count)}
              /></span>
          })
        }
      </span>
      <Button onClick={onClickSplitOk} type="primary">确定</Button>
    </div>
  }

  const onNewPallet = () => {
    const newId = new Date().getTime();
    const temp = [].concat(pallets);
    temp.push({ id: newId, _selected: true, _isNew: true })
    setPallets(temp);
  }

  const onPkgMove = (id, pallet_id, isDelivery) => {
    const temp = [].concat(packages);
    const find = temp.find(x => x.id === id);
    if (find) {
      find.pallet_id = pallet_id;
      find._selected = isDelivery;
    }
    setPackages(temp);
  }

  const menu = (type, id, pid, count, isDelivery, flag) => {
    const targetPallets = pallets.filter(x => (!x._selected && !isDelivery) || (isDelivery && x._selected === isDelivery));
    return <Menu>
      {
        isDelivery && flag === 0 && <Menu.Item disabled style={{ width: '100%', color: 'black', textAlign: 'center', backgroundColor: 'rgb(252, 240, 200)' }}>--拼托区域内部--</Menu.Item>
      }
      {
        isDelivery && flag === 1 && <Menu.Item disabled style={{ width: '100%', color: 'black', textAlign: 'center', backgroundColor: 'rgb(252, 240, 200)' }}>--移出待拼托区域--</Menu.Item>
      }
      {
        !isDelivery && flag === 0 && <Menu.Item disabled style={{ width: '100%', color: 'black', textAlign: 'center', backgroundColor: 'rgb(218, 247, 207)' }}>--待拼托区域内部--</Menu.Item>
      }
      {
        !isDelivery && flag === 1 && <Menu.Item disabled style={{ width: '100%', color: 'black', textAlign: 'center', backgroundColor: 'rgb(218, 247, 207)' }}>--移出拼托区域--</Menu.Item>
      }
      {
        type === 0 && <Menu.Item onClick={() => onPkgMove(id, -1, isDelivery)} key={-1} icon={<ImportOutlined />}>
          <span style={{ padding: '0 1rem' }}>散箱列表</span>
        </Menu.Item>
      }
      {(targetPallets.length > 0 && type === 0) && <Menu.Divider />}
      {
        (targetPallets.length > 0 && targetPallets.length <= 5) && <Menu.SubMenu title={"托盘[1-" + targetPallets.length + "]"}>
          {
            targetPallets.map((x, i) => {
              return <Menu.Item disabled={type === 0 && x.id === pid} onClick={() => onPkgMove(id, x.id, isDelivery)} key={x.id} icon={<ImportOutlined />}>
                <span style={{ padding: '0 1rem' }}>托盘{i + 1}</span>
              </Menu.Item>
            })
          }
        </Menu.SubMenu>
      }
      {
        targetPallets.length > 5 && targetPallets.map((x, i) => {
          if ((i === 0 || (i + 1) % 5 === 0) && ((i > 0 || (i + 1) != targetPallets.length)) /*|| type !== 0*/) {
            return <Menu.SubMenu title={"托盘[" + (i === 0 ? 1 : i + 2) + "-" + (i === 0 ? (i + 5) : (i + 6) >= (targetPallets.length) ? targetPallets.length : i + 6) + "]"}>
              {
                [0, 1, 2, 3, 4].map(y => {
                  const target = targetPallets[i === 0 ? y : i + y + 1];
                  if (!target) return undefined;
                  return <Menu.Item disabled={type === 0 && target.id === pid} onClick={() => onPkgMove(id, target.id, isDelivery)} key={target.id} icon={<ImportOutlined />}>
                    <span style={{ padding: '0 1rem' }}>托盘{i === 0 ? i + y + 1 : i + y + 2}</span>
                  </Menu.Item>
                })
              }
            </Menu.SubMenu>
          }
        })
      }
      {(flag === 0 && targetPallets.length > 0) && <Menu.Divider />}
      {flag === 0 && <Menu.Item onClick={() => onSplitCarton(id, count)} key={9999} icon={<EditOutlined />}>
        <span style={{ color: 'blue', padding: '0 1rem' }}>分解箱数</span>
      </Menu.Item>
      }
    </Menu>
  }

  const onCheckAll = (e) => {
    const checked = e.target.checked;
    const temp1 = pallets.map(x => (Object.assign({
      selected: checked
    }, x)));
    setPallets(temp1);
    const temp2 = packages.map(x => (
      Object.assign({
        selected: checked
      }, x)));
    setPackages(temp2);
  }

  const onCancelPallet = (id) => {
    const temp = [].concat(packages);
    temp.filter(x => x.pallet_id === id).forEach(x => {
      x.pallet_id = -1;
    });
    setPackages(temp);

    const t = [].concat(pallets);
    t.splice(t.findIndex(x => x.id === id), 1);
    setPallets(t);
  }

  const onCheckPallet = (e, id) => {
    const checked = e.target.checked;
    const temp = [].concat(pallets);
    const temp1 = temp.find(x => x.id === id);
    temp1.selected = checked;
    setPallets(temp);
  }
  const onCheckCarton = (e, id) => {
    const checked = e.target.checked;
    const temp = [].concat(packages);
    const temp1 = temp.find(x => x.id === id);
    temp1.selected = checked;
    temp1._checked = checked;
    setPackages(temp);
  }

  const onChangePalletType = (e, id) => {
    const checked = e.target.checked;
    const temp = [].concat(pallets);
    const find = temp.find(x => x.id === id);
    if (find) find.type = checked ? 1 : 0;
    setPallets(temp);
  }

  const total = {
    weight: 0,
    count: 0,
    amount: 0
  }
  packages.forEach((item, index) => {
    total.weight += (item.weight || 0);
    total.count += (item.carton_count * item.count_per_carton);
    total.amount += 0;
  });

  const cartons = packages.filter(x => x.pallet_id === -1);
  let total_cartons_weights = 0;
  cartons.forEach((item, index) => {
    total_cartons_weights += (item.weight || 0);
  });
  const isAllChecked = (cartons.filter(x => !x.selected).length === 0 && pallets.filter(x => !x.selected).length === 0);
  const initValue = [
    { name: 'id', value: plan && plan.id },
    { name: 'delivery_type_id', value: typeId },
    { name: 'plan_date', value: planDate },
    { name: 'buyer_id', value: buyerId },
    { name: 'destination_port_id', value: destinationPortId },
    { name: 'company_id', value: companyId},
    { name: 'transport_id', value: transportId },
    { name: 'container_id', value: destinationPortId && containerId },
  ];

  const ports = [];
  const transports = [];
  const companies = [];
  orders.forEach(x => {
    if (transports.find(y => y.id === x.transport_id) === undefined)
      transports.push({ id: x.transport_id, name: x.transport_name });
    if (ports.find(y => y.id === x.destination_port_id) === undefined)
      ports.push({ id: x.destination_port_id, name: x.destination_port_name });
      if (companies.find(y => y.id === x.company_id) === undefined)
      companies.push({ id: x.company_id, name: company.find(z=>z.id===x.company_id).abbr });     
  });

  const onMoveToDeliveryCombine = () => {
    const temp = [].concat(packages);
    const selected = temp.filter(x => x._checked);
    if (selected.length === 0) return;
    const newId = new Date().getTime();
    selected.forEach(x => {
      x._selected = true;
      x._checked = false;
      x.pallet_id = newId;
    })
    setPackages(temp);

    const temp1 = [].concat(pallets);
    temp1.push({ id: newId, _selected: true, _isNew: true })
    setPallets(temp1);
  }

  const onMoveToDelivery = (id, flag) => {
    const temp = [].concat(pallets);
    const find = temp.find(x => x.id === id);
    if (find) {
      find._selected = !find._selected;
      const temp1 = [].concat(packages);
      temp1.forEach((x, i) => {
        if (x.pallet_id === id) {
          temp1[i]._selected = !temp1[i]._selected;
        }
      })
      setPackages(temp1);
      setPallets(temp);
    }
  }

  let totalDeliveryWeights = 0;
  const body = (isDelivery) => {
    const targetPallets = pallets.filter(x => (!x._selected && !isDelivery) || (isDelivery && x._selected === isDelivery));
    const targetCartons = packages.filter(x => x.pallet_id === -1).filter(x => (!x._selected && !isDelivery) || (isDelivery && x._selected === isDelivery));
    if (targetPallets.length === 0 && targetCartons.length === 0) {
      return <Empty />
    }
    let cartonWeights = sum(targetCartons, 'weight');
    let cartonCounts = sum(targetCartons, 'count');
    let totalWeights = 0;
    let totalCounts = 0;
    if (isDelivery) {
      totalDeliveryWeights = cartonWeights;
    }

    return <table className="table table_delivery" style={{ border: '2px solid #f7f7f7' }} >
      <thead style={{ backgroundColor: '#f7f7f7' }}>
        <tr>
          <th className="th" rowSpan="2" width="60px"><Checkbox disabled checked={false} onChange={onCheckAll} /></th>
          <th className="th" rowSpan="2" width="300px">产品号</th>
          <th className="th" rowSpan="2" width="120px">发货日期</th>
          {displayColumn.indexOf(0) > -1 && <th className="th" rowspan="2" >供应商</th>}
          {displayColumn.indexOf(1) > -1 && <th className="th" rowspan="2" >箱单号</th>}
          {displayColumn.indexOf(2) > -1 && <th className="th" rowspan="2" >PO编码</th>}
          <th className="th" rowspan="2" >箱数</th>
          <th className="th2" colspan="2">数量(件)</th>
          <th className="th2" rowSpan="2">重量<br />(千克)</th>
          <th className="th2" rowSpan="2">总重量<br />(千克)</th>
          <th className="th2" rowSpan="2" width="200px">操作<br /></th>
        </tr>
        <tr>
          <th align="center" className="th2">件数/箱</th>
          <th align="center" className="th2">总件数</th>
        </tr>
      </thead>
      <tbody>
        {
          targetPallets.map((item, pindex) => {
            const palletPackage = packages.filter(x => x.pallet_id === item.id);
            let total_weights = 0;
            let total_counts = 0;
            for (let i = 0; i < palletPackage.length; i++) {
              total_weights += (palletPackage[i].weight || 0);
              total_counts += (palletPackage[i].count || 0);
            }
            totalWeights += total_weights;
            totalCounts += total_counts;
            if (isDelivery) {
              totalDeliveryWeights += total_weights;
            }
            const chk = chkPallet(palletPackage);
            item._status = chk.status;
            !chk.status && (item.selected = false);
            return [
              <tr>
                <td style={{ backgroundColor: '#f7f7f7' }} className="td" colspan={9 + displayColumn.length}>
                  <div style={{ fontSize: "1.1rem", display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <strong>第{pindex + 1}托盘 {!item.supplier_id && <a>[新]</a>} {chk.content} {item.recive_status && (<Tag color="#1890ff">已到货</Tag>)} {!item.recive_status && (<Tag color="#FF2D2D">未到货</Tag>)} </strong>
                    {isDelivery && <Button danger onClick={() => onMoveToDelivery(item.id, false)} size="small">移出拼托区域</Button>}
                    {!isDelivery && <Button type="primary" onClick={() => onMoveToDelivery(item.id, true)} size="small">移到拼托区域</Button>}
                    {/* <Button onClick={() => onCancelPallet(item.id)} danger size="small">拆托到散箱</Button> */}
                  </div>
                </td>
              </tr>,
              palletPackage.map((carton, index) => {
                return <tr>
                  {
                    index === 0 && <td className="td" align="center" rowspan={palletPackage.length}>
                      <Checkbox disabled onChange={(e) => onCheckPallet(e, item.id)} checked={item.selected} /></td>
                  }
                  <td className="td">
                    {carton.goods_spec_name}&nbsp;
                    {carton.goods_name}&nbsp;
                    {carton.size}
                  </td>
                  <td align="center" className="td">
                    {carton.package_delivery_date}
                  </td>
                  {
                    displayColumn.indexOf(0) > -1 && <td className="td" >
                      {carton.supplier_name}
                    </td>
                  }
                  {
                    displayColumn.indexOf(1) > -1 && <td className="td" align="center" >
                      {carton.package_no}
                    </td>
                  }
                  {
                    displayColumn.indexOf(2) > -1 && <td className="td" align="center" >
                      {carton.po_code}
                    </td>
                  }
                  <td align="right" className="td">{toThousands(carton.carton_count)}</td>
                  <td align="right" className="td">{toThousands(carton.count_per_carton)}</td>
                  <td align="right" className="td">{toThousands(carton.carton_count * carton.count_per_carton)}</td>
                  <td align="right" className="td">{toThousands(carton.weight.toFixed(2))}</td>
                  {
                    index === 0 && <td align="right" className="td" rowspan={palletPackage.length}>{toThousands(total_weights.toFixed(2))}</td>
                  }
                  {
                    <td align="right" className="td">
                      <div style={{display:'inline-flex', alignItems:'center', justifyContent:'center'}}>
                      <Dropdown.Button size="small" overlay={() => menu(0, carton.id, item.id, item.carton_count, isDelivery, 0)} style={{ backgroundColor: '#f0f0f0f' }} icon={<CaretDownOutlined />} >
                        移动到...
                      </Dropdown.Button>
                      &nbsp;&nbsp;
                      <Dropdown.Button size="small" overlay={() => menu(0, carton.id, item.id, item.carton_count, !isDelivery, 1)} style={{ backgroundColor: '#f0f0f0f' }} icon={<CaretDownOutlined />} >
                        <span style={{ color: 'red' }}>移出到...</span>
                      </Dropdown.Button>
                      </div>
                    </td>
                  }
                </tr>
              })
            ]
          })
        }
        {
          <tr>
            <td style={{ backgroundColor: '#f7f7f7' }} className="td" colspan={9 + displayColumn.length}>
              <div style={{ fontSize: "1.1rem", display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <strong>散箱</strong>
                {!isDelivery && <Button type="primary" disabled={packages.filter(x => x._checked).length === 0} onClick={onMoveToDeliveryCombine} size="small">移到拼托区域(合并成新托)</Button>}
              </div>
            </td>
          </tr>
        }
        {
          targetCartons.map((item, index) => {
            return <tr>
              <td className="td" align="center"><Checkbox disabled={isDelivery} onChange={(e) => onCheckCarton(e, item.id)} checked={item._checked} /></td>
              <td className="td">
                {item.goods_spec_name}&nbsp;
                {item.goods_name}&nbsp;
                {item.size}&nbsp;
                {item.recive_status && (<Tag color="#1890ff">已到货</Tag>)} {!item.recive_status && (<Tag color="#FF2D2D">未到货</Tag>)}
              </td>
              <td className="td" align="center" >
                {item.package_delivery_date}
              </td>
              {
                displayColumn.indexOf(0) > -1 && <td className="td" >
                  {item.supplier_name}
                </td>
              }
              {
                displayColumn.indexOf(1) > -1 && <td className="td" align="center" >
                  {item.po_code}
                </td>
              }
              {
                displayColumn.indexOf(2) > -1 && <td className="td" align="center" >
                  {item.po_code}
                </td>
              }

              <td align="right" className="td">{toThousands(item.carton_count)}</td>
              <td align="right" className="td">{toThousands(item.count_per_carton)}</td>
              <td align="right" className="td">{toThousands(item.carton_count * item.count_per_carton)}</td>
              <td align="right" className="td">{toThousands(item.weight.toFixed(2))}</td>
              {
                index === 0 && <td align="right" className="td" rowspan={targetCartons.length}>
                  {
                    toThousands(cartonWeights.toFixed(2))
                  }
                </td>
              }
              {
                <td align="right" className="td">
                  <div style={{ display: 'inline-flex', alignItems:'center', justifyContent:'center' }}>
                    <Dropdown.Button size="small" overlay={() => menu(1, item.id, -1, item.carton_count, isDelivery, 0)} style={{ backgroundColor: '#f0f0f0f' }} icon={<CaretDownOutlined />} >
                      移动到...
                    </Dropdown.Button>
                    &nbsp;&nbsp;
                    <Dropdown.Button size="small" overlay={() => menu(0, item.id, -1, item.carton_count, !isDelivery, 1)} style={{ backgroundColor: '#f0f0f0f' }} icon={<CaretDownOutlined />} >
                      <span style={{ color: 'red' }}>移出到...</span>
                    </Dropdown.Button>
                  </div>
                </td>
              }
            </tr>
          })
        }
      </tbody>
      <tfoot style={{ backgroundColor: '#f7f7f7' }}>
        <td className="td" colSpan={3 + displayColumn.length}>
          <div style={{ fontSize: '1.1rem', display: 'flex', justifyContent: 'space-between' }}>
            <strong></strong>
            <strong>合计：{targetPallets.length}托   +  {sum(targetCartons, 'carton_count')}散箱</strong>
          </div>
        </td>
        <td className="td" colSpan="2">
          <div style={{ textAlign: 'right', fontSize: '1.1rem' }}>
            <strong>总数量:  {toThousands(cartonCounts + totalCounts)}</strong>
          </div>
        </td>
        <td className="td" colSpan="2">
          <div style={{ textAlign: 'right', fontSize: '1.1rem' }}>
            <strong>总重量:  {toThousands((cartonWeights + totalWeights).toFixed(2))}</strong>
          </div>
        </td>
        <td className="td"></td>
      </tfoot>
    </table>
  }

  const body0 = body(true);
  const body1 = body(false);
  return (
    <div style={{ padding: '0.5rem 1.5rem' }}>
      <Form form={form} preserve={false} onFinish={onSave} fields={initValue}>
        <Row>
          <Col span={12}>
            <Form.Item hidden={true} name="id" >
              <Input />
            </Form.Item>
          </Col>
        </Row>

        <div className="delivery-new-header">
          <Row>
            <Form.Item label="发货类型" name="delivery_type_id" rules={[{ required: true, message: '请选择发货类型!' }]}>
              <Select
                placeholder="类型"
                onChange={setTypeId}
                style={{ width: '80px' }}
              >
                <Select.Option key={1} value={1}>
                  FCL
                </Select.Option>
                <Select.Option key={2} value={2}>
                  LCL
                </Select.Option>
              </Select>
            </Form.Item>
            <Form.Item label="计划日期" name="plan_date" rules={[{ required: true, message: '请选择发货类型!' }]}>
              <DatePicker allowClear={false} onChange={(value) => setPlanDate(moment(value, 'YYYY-MM-DD'))} placeholder="发货日期" style={{ width: '130px' }} />
            </Form.Item>
            <Form.Item label="客户" name="buyer_id" rules={[{ required: true, message: '请选择客户!' }]}>
              <Select
                showSearch="true"
                optionFilterProp="children"
                placeholder="请选择客户"
                onChange={onChangeBuyer}
                style={{ width: '260px' }}
              >
                {buyers.map(item => (
                  <Select.Option key={item.id} value={item.id}>
                    [{item.name_nick}] - {item.name_en}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item label="发货公司" name="company_id" rules={[{ required: true, message: '请选择发货公司!' }]}>
              <Select
                optionFilterProp="children"
                onChange={setCompanyId}
                style={{ width: '100px' }}
              >
                {companies.map(item => (
                  <Select.Option key={item.id} value={item.id}>
                    {item.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item label="港口" name="destination_port_id" rules={[{ required: true, message: '请选择港口!' }]}>
              <Select
                optionFilterProp="children"
                placeholder="请选择港口"
                onChange={setDestinationPortId}
                style={{ width: '140px' }}
              >
                {ports.map(item => (
                  <Select.Option key={item.id} value={item.id}>
                    {item.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item label="运输类型" name="transport_id" rules={[{ required: true, message: '请选择运输类型!' }]}>
              <Select
                optionFilterProp="children"
                placeholder="请选择运输类型"
                onChange={setTransportId}
                style={{ width: '80px' }}
              >
                {transports.map(item => (
                  <Select.Option key={item.id} value={item.id}>
                    {item.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item label="箱型" name="container_id" rules={[{ required: true, message: '请选择箱型!' }]}>
              <Select
                optionFilterProp="children"
                onChange={setContainerId}
                style={{ width: '80px' }}
              >
                {portContainer.filter(x => x.port_id === destinationPortId).map(item => (
                  <Select.Option key={item.container_id} value={item.container_id}>
                    {(container.find(c => c.id === item.container_id) || {}).name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            {(containerId && destinationPortId) && <span style={{ padding: '0.25rem 0.5rem', fontSize: '1.5rem' }}>限重：<strong>{limit}</strong>KG</span>}
          </Row>
          {
            orders.filter(o => o.destination_port_id === destinationPortId && o.transport_id === transportId && o.company_id === companyId).length > 0 && 
            <Form.Item label="" name="orders">
              <Checkbox.Group
                options={
                  orders.filter(o => o.destination_port_id === destinationPortId && o.transport_id === transportId && o.company_id === companyId).map(x =>
                    ({ label: `#${x.po_code}`, value: x.id }))
                }
                onChange={onChangeSelectedOrder}
              />
            </Form.Item>
          }
        </div>
        {
          packages.length > 0 && <div className="delivery-content">
            <div className="delivery-content-header"><h3>发货拼托区域  {
              totalDeliveryWeights > limit ?
                <Tag color="#f50">超重{(totalDeliveryWeights - limit).toFixed(2)}</Tag> :
                <Tag color="#87d068">总重：{totalDeliveryWeights.toFixed(2)}KG</Tag>}</h3> <Button onClick={onNewPallet} type="primary" icon={<PlusOutlined />}>新建托盘</Button> </div>
            <div className="delivery-content-body">
              {body0}
            </div>
          </div>
        }
        {/* <div className="delivery-new-filter">
          {
            packages.length > 0 && <Checkbox.Group
              options={[{ label: '显示供应商', value: 0 }, { label: '显示PO编码', value: 1 }, { label: '显示价格', value: 2 }]}
              onChange={setDisplayColumn}
            />
          }
        </div> */}
        <div className="delivery-wait-content">
          <div className="delivery-content-header"><h3>待发货箱单区域</h3> </div>
          <div className="delivery-content-body">
            {body1}
          </div>
        </div>
        <Divider />
        <div className="page-footer">
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {packages.length > 0 && <Space size="large">
              <Form.Item label="运费" name="feight" >
                <InputNumber min={0} />
              </Form.Item>
              <Form.Item label="到港提货费" name="ddc" >
                <InputNumber min={0} />
              </Form.Item>
              <Form.Item label="发票号" name="delivery_no" >
                <Input />
              </Form.Item>
            </Space>
            }
          </div>
          <Space size="large">
            <Button onClick={onCloseCallback} icon={<CloseOutlined />}>关 闭</Button>
            {
              !isReadonly && <div style={{ display: 'flex', alignItems: 'center' }}>
                <Button htmlType="submit" type="primary" icon={<CheckOutlined />}>保存到发货计划</Button>
              </div>
            }
          </Space>
        </div>
        <div style={{ height: '50vh' }}></div>
      </Form>
      <Page
        title={`拆分箱数`}
        width="75vw"
        onCloseCallback={() => setShowSplit(false)}
        body={splitBody()}
        visible={isShowSplit}
      />
    </div >)
});
